var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.575,
    height: 14.584,
    viewBox: "0 0 14.575 14.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_10_16",
    "data-name": "Component 10 \\u2013 16",
    transform: "translate(0 0.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12685",
    "data-name": "Path 12685",
    d: "M297,86.835c.073-.3.149-.609.218-.915.169-.753.334-1.507.495-2.231l2.8,2.809c-.236.059-.507.127-.779.193l-2.24.545c-.263.064-.36.023-.494-.209Z",
    transform: "translate(-297 -73.263)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M0,9.6c2.388-2.4,5.686-5.721,8.074-8.12l0,0c.377-.4.748-.81,1.155-1.182a1.188,1.188,0,0,1,1.6.028c.475.446.934.912,1.381,1.386a.911.911,0,0,1,.031,1.23c-.432.46-.9.891-1.344,1.324h0L2.8,12.4Z",
    transform: "translate(1.533)",
    fill: "#600097",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bdc6e669876492631e180cfaaaefe03b.svg";
export { ForwardRef as ReactComponent };